import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../../../api/client";

const HQ_KEY = ["headquarters"];

function useHeadquarters() {
  return useQuery({
    queryKey: HQ_KEY,
    queryFn: () => apiClient.get("/api/v1/headquarters/").then((r) => r.data),
  });
}

function useCreateHeadquarter() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body) =>
      apiClient.post("/api/v1/headquarters/", body).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: HQ_KEY }),
  });
}

function useUpdateHeadquarter() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...body }) =>
      apiClient.patch(`/api/v1/headquarters/${id}/`, body).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: HQ_KEY }),
  });
}

function useDeleteHeadquarter() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) => apiClient.delete(`/api/v1/headquarters/${id}/`),
    onSuccess: () => qc.invalidateQueries({ queryKey: HQ_KEY }),
  });
}

// Acceso a una sede (solo su administrador): darle o quitarle acceso a otro
// propietario. Las sedes visibles de cada uno cambian, así que se refresca
// toda la lista.
function useAddHeadquarterMember() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, user }) =>
      apiClient
        .post(`/api/v1/headquarters/${id}/members/`, { user })
        .then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: HQ_KEY }),
  });
}

function useRemoveHeadquarterMember() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, user }) =>
      apiClient
        .delete(`/api/v1/headquarters/${id}/members/${user}/`)
        .then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: HQ_KEY }),
  });
}

export {
  useHeadquarters,
  useCreateHeadquarter,
  useUpdateHeadquarter,
  useDeleteHeadquarter,
  useAddHeadquarterMember,
  useRemoveHeadquarterMember,
  HQ_KEY,
};
